var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.cartItem.loading
      ? _c("div", [_c("CartItemContentLoader")], 1)
      : _c(
          "div",
          {
            staticClass: "cart__line-item line-item js-line-item",
            class: {
              "cart__line-item--draggable":
                _vm.orderType == "offer" &&
                !(_vm.isFirstItem && _vm.isLastItem) &&
                _vm.$store.getters.changesAllowed,
              "line-item--alternative": _vm.cartItem.is_alternative
            },
            attrs: { role: "listitem" }
          },
          [
            _vm.orderType == "offer" &&
            !(_vm.isFirstItem && _vm.isLastItem) &&
            _vm.$store.getters.changesAllowed
              ? _c("div", { staticClass: "cart__line-item__controls" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "cart__line-item__move cart__line-item__move--up",
                      attrs: { disabled: _vm.isFirstItem },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.moveUp($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "screen-reader-text" }, [
                        _vm._v("Siirrä ylöspäin")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "cart__line-item__move cart__line-item__move--drag js-handle",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "screen-reader-text" }, [
                        _vm._v("Raahaa")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "cart__line-item__move cart__line-item__move--down",
                      attrs: { disabled: _vm.isLastItem },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.moveDown($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "screen-reader-text" }, [
                        _vm._v("Siirrä alaspäin")
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cart__column cart__column--product",
                class: {
                  "cart__column--product--offer": _vm.orderType == "offer"
                }
              },
              [
                _c("div", { staticClass: "line-item__image-container" }, [
                  _vm.cartItem && _vm.cartItem.image
                    ? _c("a", { attrs: { href: _vm.cartItem.link } }, [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: _vm.cartItem.image.productThumbnail,
                              expression: "cartItem.image.productThumbnail"
                            }
                          ],
                          staticClass: "cart-item__image",
                          attrs: {
                            srcset:
                              _vm.cartItem.image.productThumbnail +
                              " 1x, " +
                              _vm.cartItem.image.productThumbnailX2 +
                              " 2x",
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line-item__info" }, [
                  _c(
                    "div",
                    { staticClass: "line-item__info__main" },
                    [
                      _vm.orderType == "offer" && _vm.cartItem.position_id
                        ? _c("p", { staticClass: "line-item__info__text" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.cartItem.position_id) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h3", { staticClass: "line-item__title" }, [
                        _c(
                          "a",
                          {
                            staticClass: "line-item__link",
                            attrs: { href: _vm.cartItem.link }
                          },
                          [
                            _vm.cartItem.is_modeo_plus
                              ? _c("span", { staticClass: "modeo-plus" }, [
                                  _vm._v("Modeo+")
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.name) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.orderType === "offer"
                        ? _c("p", { staticClass: "line-item__sku" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.cartItem.sku) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cartItem.description
                        ? _c("p", { staticClass: "line-item__description" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.cartItem.description) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.cartItem.attributes, function(attribute) {
                        return _c(
                          "p",
                          {
                            key: attribute.key,
                            staticClass: "line-item__detail",
                            class: {
                              "line-item__detail--alt": _vm.orderType != "offer"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(attribute.name) +
                                ": " +
                                _vm._s(attribute.value) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.cartItem.add_ons && _vm.cartItem.add_ons.length > 0
                    ? _c("div", { staticClass: "line-item__addons" }, [
                        _c(
                          "button",
                          {
                            staticClass: "line-item__addons__toggle",
                            class: {
                              "line-item__addons__toggle--active":
                                _vm.showAddons
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleAddons($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$modeoL10n.additional_options) +
                                "\n            "
                            ),
                            _c(
                              "span",
                              { staticClass: "line-item__addons__sum" },
                              [
                                _c("price", {
                                  attrs: {
                                    prefix: "+",
                                    "price-without-tax": _vm.addOnTotal()
                                      .price_without_tax,
                                    "price-with-tax": _vm.addOnTotal()
                                      .price_with_tax
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showAddons
                          ? _c(
                              "div",
                              { staticClass: "line-item__addons__content" },
                              _vm._l(_vm.cartItem.add_ons, function(addOn) {
                                return _c(
                                  "p",
                                  {
                                    key: addOn.key,
                                    staticClass: "line-item__addons__value"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(addOn.name) +
                                        " "
                                    ),
                                    _c("price", {
                                      attrs: {
                                        prefix: "+",
                                        "price-without-tax":
                                          addOn.prices_without_tax.price,
                                        "price-with-tax":
                                          addOn.prices_with_tax.price
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.getters.changesAllowed
                    ? _c("div", { staticClass: "line-item__actions" }, [
                        _vm.orderType == "offer"
                          ? _c(
                              "label",
                              {
                                staticClass:
                                  "line-item__button line-item__label"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cartItem.is_alternative,
                                      expression: "cartItem.is_alternative"
                                    }
                                  ],
                                  staticClass: "line-item__checkbox",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.cartItem.is_alternative
                                    )
                                      ? _vm._i(
                                          _vm.cartItem.is_alternative,
                                          null
                                        ) > -1
                                      : _vm.cartItem.is_alternative
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.cartItem.is_alternative,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.cartItem,
                                                "is_alternative",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.cartItem,
                                                "is_alternative",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.cartItem,
                                            "is_alternative",
                                            $$c
                                          )
                                        }
                                      },
                                      function($event) {
                                        return _vm.handleChange()
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(
                                  "\n            Vaihtoehtoinen tuote\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orderType == "offer"
                          ? _c(
                              "button",
                              {
                                staticClass: "line-item__button",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.editCartItem()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            Muokkaa tuotetta\n            "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "screen-reader-text" },
                                  [_vm._v(" " + _vm._s(_vm.cartItem.name))]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "line-item__button",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showConfirmaton()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$modeoL10n.remove_product) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "screen-reader-text" }, [
                              _vm._v(" " + _vm._s(_vm.cartItem.name))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.orderType == "offer"
                          ? _c(
                              "button",
                              {
                                staticClass: "line-item__button",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("duplicate", _vm.cartItem)
                                  }
                                }
                              },
                              [
                                _vm._v("\n            Kopioi\n            "),
                                _c(
                                  "span",
                                  { staticClass: "screen-reader-text" },
                                  [_vm._v(" " + _vm._s(_vm.cartItem.name))]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.orderType == "order"
              ? _c(
                  "div",
                  { staticClass: "cart__column cart__column--availability" },
                  [
                    _c("span", { staticClass: "cart__column__label" }, [
                      _vm._v(_vm._s(_vm.$modeoL10n.availability))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "availability  availability--small",
                        class: _vm.availability.status
                          ? "availability--" + _vm.availability.status
                          : ""
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.availability.text) +
                            "\n        "
                        ),
                        _vm.availability.detail
                          ? _c(
                              "span",
                              { staticClass: "availability__detail" },
                              [_vm._v(_vm._s(_vm.availability.detail))]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.orderType == "offer"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "cart__column cart__column--price cart__column--price-input"
                  },
                  [
                    _c("span", { staticClass: "cart__column__label" }, [
                      _vm._v("Kust.hinta")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "line-item__price" }, [
                      _c(
                        "span",
                        { staticClass: "line-item__price__input-container" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cartItem.cost_price,
                                expression: "cartItem.cost_price"
                              }
                            ],
                            staticClass: "line-item__price__input small",
                            attrs: {
                              type: "text",
                              disabled: !_vm.$store.getters.changesAllowed
                            },
                            domProps: { value: _vm.cartItem.cost_price },
                            on: {
                              keypress: function($event) {
                                return _vm.forceFloat()
                              },
                              change: function($event) {
                                return _vm.handleChange()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.cartItem,
                                  "cost_price",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "line-item__price__unit" },
                            [_vm._v("€")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "cart__column cart__column--price cart__column--price-input"
              },
              [
                _c("span", { staticClass: "cart__column__label" }, [
                  _vm._v(_vm._s(_vm.$modeoL10n.unit_price))
                ]),
                _vm._v(" "),
                _vm.orderType == "order"
                  ? _c(
                      "span",
                      { staticClass: "line-item__price" },
                      [
                        _c("price", {
                          attrs: {
                            "price-without-tax": _vm.unitLineTotal()
                              .unit_line_total_without_tax,
                            "price-with-tax": _vm.unitLineTotal()
                              .unit_line_total_with_tax
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderType == "offer"
                  ? _c("span", { staticClass: "line-item__price" }, [
                      _c(
                        "span",
                        { staticClass: "line-item__price__input-container" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cartItem.price,
                                expression: "cartItem.price"
                              }
                            ],
                            staticClass: "line-item__price__input small",
                            attrs: {
                              type: "text",
                              disabled: !_vm.$store.getters.changesAllowed
                            },
                            domProps: { value: _vm.cartItem.price },
                            on: {
                              keypress: function($event) {
                                return _vm.forceFloat()
                              },
                              change: function($event) {
                                return _vm.handleChange()
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.cartItem,
                                  "price",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "line-item__price__unit" },
                            [_vm._v("€")]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.orderType == "offer"
              ? _c(
                  "div",
                  { staticClass: "cart__column cart__column--profit" },
                  [
                    _c("span", { staticClass: "cart__column__label" }, [
                      _vm._v("Kate")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "line-item__price" }, [
                      _vm._v(_vm._s(_vm._f("formatPercent")(_vm.profit)) + " %")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cart__column cart__column--amount" },
              [
                _c("span", { staticClass: "cart__column__label" }, [
                  _vm._v(_vm._s(_vm.$modeoL10n.amount))
                ]),
                _vm._v(" "),
                _c("product-counter", {
                  ref: "counter",
                  attrs: {
                    "default-count": _vm.cartItem.quantity,
                    "max-count": _vm.maxCount,
                    "counter-mode": "small"
                  },
                  on: {
                    update: function($event) {
                      return _vm.changeQuantity($event)
                    },
                    change: function($event) {
                      return _vm.changeQuantity($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "cart__column cart__column--sum cart__column--sum-value"
              },
              [
                _c("span", { staticClass: "cart__column__label" }, [
                  _vm._v(_vm._s(_vm.$modeoL10n.total))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "line-item__sum" },
                  [
                    _c("price", {
                      attrs: {
                        "price-without-tax": _vm.lineTotal().price_without_tax,
                        "price-with-tax": _vm.lineTotal().price_with_tax
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "line-item__tax tax" }, [
                  _vm._v(
                    _vm._s(_vm.$modeoL10n.vat) +
                      " " +
                      _vm._s(_vm.$store.getters.displayVat)
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("DeleteItemConfirmation", {
              attrs: {
                display: _vm.showConfirmation,
                quantity: _vm.cartItem.quantity
              },
              on: {
                confirm: function($event) {
                  return _vm.remove()
                },
                cancel: function($event) {
                  _vm.showConfirmation = false
                }
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35f79269", { render: render, staticRenderFns: staticRenderFns })
  }
}